/* unplugin-vue-components disabled */import script from "./championship.vue?vue&type=script&lang=jsx"
export * from "./championship.vue?vue&type=script&lang=jsx"

import "./championship.vue?vue&type=style&index=0&id=47ceccbe&lang=less&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47ceccbe"]])

export default __exports__